export const lineHeightRange = ['15px', '30px'];
